import { useEffect } from 'react';
import { useRouter } from 'shared/hooks/use-router';
import { getQuery } from 'shared/route-query/utils/get-query';
import { deepCompare } from 'shared/utils/deepCompare';
import type { ParsedUrlQuery } from 'querystring';
interface QueryInterface<T> {
  data?: T;
  onChange: (data: T) => void;
  skip?: boolean;
  keys: Array<keyof ParsedUrlQuery>;
}
export const useQuery = <T extends ParsedUrlQuery,>({
  data,
  onChange,
  skip,
  keys
}: QueryInterface<T>) => {
  const router = useRouter();
  const {
    query
  } = router;
  useEffect(() => {
    if (skip) return;
    const {
      relatedQuery
    } = getQuery(query, keys);
    if (deepCompare(data, relatedQuery)) return;
    onChange(relatedQuery as T);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, skip]);
  useEffect(() => {
    if (skip || !data) return;
    const {
      unrelatedQuery,
      relatedQuery
    } = getQuery(query, keys);
    if (deepCompare(data, relatedQuery)) return;
    router.replaceQuery({
      ...unrelatedQuery,
      ...data
    }, {
      shallow: true
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, skip]);
};